import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from "react-redux";
import {store} from "./store";
import {isMobile} from "react-device-detect";

if (isMobile) {
    window.onerror = function (message, source, lineno, colno, error) {
        console.info("JS Error:", message);
        return true; // Prevent default browser error handling
    };
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);


root.render(
    <Provider store={store}>
                <App/>
    </Provider>,
);
